import { changeDataAccelerationTaskSchedule } from '../../app/actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { AppState } from '../../app/state/AppState';
import { currentUserIsAdmin } from '../../app/utils/MixedContentHelpers';
import { Messages } from '../../codegen/Localize';
import { IDatasourceActions } from '../../datasource/ServerApi/types/IDatasourceActions';
import { IAccelerationTaskInfo } from '../../ts/models/IAccelerationTaskInfo';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';

export const ChangeDataAccelerationScheduleEntityAction:
    IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeFrequency_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: changeDataAccelerationTaskSchedule
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return currentUserIsAdmin(state);
}
